// https://stackoverflow.com/questions/36639681/how-to-copy-text-from-a-div-to-clipboard
export default function copyToClipboard(containerid) {
  if (document.selection) {
    var range = document.body.createTextRange();
    range.moveToElementText(document.getElementById(containerid));
    range.select().createTextRange();
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// to deselect
  } else if (window.getSelection) {
    var range = document.createRange();
    var selection = window.getSelection();
    selection.removeAllRanges();// to deselect
    range.selectNode(document.getElementById(containerid));
    selection.addRange(range);
    document.execCommand("copy");
    selection.removeAllRanges();// to deselect
  }
}
